import { createAction } from 'redux-actions';

export const userDocumentUpdate = createAction('USER_DASHBOARD_USER_DOCUMENT_UPDATE');
export const userDocumentUpdateSuccess = createAction('USER_DASHBOARD_USER_DOCUMENT_UPDATE_SUCCESS');
